import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import {
  CODE_ERRORS,
  ENDPOINT_API_PATH,
} from '../Definitions/ValidateBigDataQuestionDef';

const autoGenerateSuccess = (ticketId: string, answers: string[]) => {
  const validateBigDataQuestionSuccess: IMockProps = {
    doc: {
      code: 'Validação com Sucesso',
      message: 'Validação com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ticketId,
        answers,
      },
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return validateBigDataQuestionSuccess;
};

const autoGenerateSuccessANSWERS = autoGenerateSuccess(MocksDef.TICKET_ID, [
  'Kennametal do Brasil',
  'ES > SP • Dezembro',
  'Rodrigo Barreto',
]);

const generatedSuccessMocks = [autoGenerateSuccessANSWERS];

const autoGenerate = (ticketId: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType) => {
      const body = {
        ticketId,
        answers:
          error.code === '-1'
            ? ['Sandvik do Brasil', 'RJ > SP • Dezembro', 'Raphaela Barros']
            : error.code === '-307'
            ? ['WEG S.A.', 'POA > SP • Dezembro', 'Raphael de Barros']
            : null,
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
            metadata: error.metadata,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate(MocksDef.TICKET_ID);
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateBigDataQuestionMocks = [
  ...generatedSuccessMocks,
  ...errorsGenerated,
];
export default ValidateBigDataQuestionMocks;
